import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteNoticeListMutation,
  DeleteNoticeListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { EventData, EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../../useGraphQlClient";
import { NoticeListIdentity } from "./useNoticeLists";

const deleteNoticeListMutation = graphql(`
  mutation deleteNoticeList($id: Int!) {
    deleteNoticeList(id: $id)
  }
`);

/** The response is a bare boolean, so the list being deleted comes from the caller. */
type TrackingContext = {
  list: NoticeListIdentity;
  trackingData?: EventData;
};

export function useDeleteNoticeList(
  { list, trackingData }: TrackingContext,
  options?: UseMutationOptions<
    DeleteNoticeListMutation,
    unknown,
    DeleteNoticeListMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const queryClient = useQueryClient();
  return useGraphQlMutation(deleteNoticeListMutation, {
    ...options,
    onSuccess: async (data, vars, ctx) => {
      await queryClient.invalidateQueries(["noticeLists"]);
      logEvent(EventNames.listDeleted, {
        ...trackingData,
        "List Name": list.name,
        "List id": list.id,
      });
      options?.onSuccess?.(data, vars, ctx);
    },
  });
}
